import { useState, useEffect, useCallback } from 'react';
import request from '../utils/request';
import type { TagItem } from '../types/admin';

const useTagsManage = () => {
  const [data, setData] = useState<TagItem[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await request.get<TagItem[]>('/select/tags');
      setData(Array.isArray(res.data) ? res.data : []);
    } catch (err: unknown) {
      console.error(err instanceof Error ? err.message : '获取数据失败');
    } finally {
      setLoading(false);
    }
  }, []);

  const addTag = useCallback( (params: { value: string; label: string }) => {
      return request.post<null>('/tags-manage/add', params).then((res) => {
        if (res?.success) {
          fetchData();
        }
      });
    },
    [fetchData]
  );

  const deleteTag = useCallback((id: number | string) => {
      return request.post<null>('/tags-manage/delete', { id })
      .then((res) => {
        if (res?.success) {
          fetchData();
        }
      });
    },
    [fetchData]
  );

  const updateTag = useCallback((params: { id: number | string; value: string; label: string }) => {
      return request.post<null>('/tags-manage/edit', params).then((res) => {
        if (res?.success) {
          fetchData();
        }
      });
    },
    [fetchData]
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, addTag, deleteTag, updateTag };
};

export default useTagsManage;
